import {
  BrilliantDeviceTypes,
  IBrilliantSwitchCard,
} from "../../interfaces/interfaces";
import { ReactComponent as Switch } from "../../img/Devices/Switch.svg";

import BrilliantDeviceCard from "./BrilliantDeviceCard";

const switchIcon = (isReconfiguring: boolean) => {
  return (
    <Switch
      title="Smart Dimmer Switch"
      className={
        isReconfiguring
          ? "brilliant-card-img-left brilliant-card-img-left-stroke disabled"
          : "brilliant-card-img-left brilliant-card-img-left-stroke"
      }
    />
  );
};

export interface BrilliantSwitchCardProps {
  data: IBrilliantSwitchCard;
  isSmartCardCredentialsEnabledStories?: boolean;
  isProView?: boolean;
}

const BrilliantSwitchCard: React.FC<BrilliantSwitchCardProps> = ({
  data,
  isProView,
}) => {
  return (
    <div>
      <BrilliantDeviceCard
        id={data.id}
        name={data.name}
        description="Smart Dimmer Switch"
        isReconfiguring={data.isReconfiguring}
        icon={switchIcon(data.isReconfiguring)}
        isProView={isProView}
        shouldShowSettingsRender={isProView}
        deviceType={BrilliantDeviceTypes.SWITCH}
      />
      {isProView && <div className="brilliant-card-container-reboot" />}
    </div>
  );
};
export default BrilliantSwitchCard;
